import axios from 'axios'
import Cookies from 'js-cookie'
import CommonAPI from '../api/common-api'

export default class Session {

  static get HOST () {
    // return 'https://home.asnpce.com:7776'
    // return 'http://localhost:7776'
    return ''
  }

  constructor (showErrorAlert = true, forLogin = false, timeout = 60000) {
    this.showErrorAlert = showErrorAlert
    this.ins = axios.create({
      timeout: timeout,
      // headers:{
      //   'X-TOKEN': localStorage.getItem('x-token')
      // }
    })

    const path = location.pathname
    if (!forLogin) {
      // ログイン済みであればcookieが設定されているはず)
      const token = Cookies.get('XSRF-TOKEN')
      if (!token && path !== '/' && path !== '/login') {
        // redirect('/')
      }
      this.ins.defaults.headers.common = {
        'X-XSRF-TOKEN': token
      }
      this.ins.defaults.withCredentials = true
    }
    this.ins.interceptors.response.use(
      response => {
        return response.data
      },
      error => {
        let status = 0
        let data
        console.error(error)
        if (error.response !== undefined) {
          status = error.response.status
          data = error.response.data
          console.log(`error: ${status}`)
          console.log(`data: ${JSON.stringify(data)}`)
          console.log(`message: ${error.response.message}`)
        }

        if (status === 401 || status === 403) {
          if (path !== '/' 
              && path !== '/login'
              && path !== '/sign-up'
              && path !== '/reset-password') {
            if(status === 403){
              alert('権限がありません')
            }
            CommonAPI.logout()
              .then(res => {
                redirect('/login')
              })
              .catch(err => {
                console.error(err)
                redirect('/login')
              })
          }
        } else if (data !== undefined && data.errorCode > 999) {
          // サーバ側でエラーのJSONを返したらここで表示する
          console.log(data.message)
          alert(data.message)
        } else if (this.showErrorAlert) {
          if (status >= 500) {
            alert('サーバでエラーが発生しました')
          } else {
            alert('通信に失敗しました')
          }
        }
        return Promise.reject(error)
      })
  }

  makeContentType () {
    // defaultはapplication-jsonなので何もしない
    return {}
  }
}

const redirect = (url) => {
  location.href = url
}



// WEBPACK FOOTER //
// ./src/assets/js/api/session.js